/**
 * @generated SignedSource<<c355c55e0c90f02830c2365a0b6d2fd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserPropertyFragment$data = {
  readonly properties: {
    readonly property: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly value: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useUserPropertyFragment";
};
export type useUserPropertyFragment$key = {
  readonly " $data"?: useUserPropertyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserPropertyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserPropertyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Properties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "14bd65424561dd69e1cc06adb98ef687";

export default node;
